import React from "react";

import { MenuVertical } from "icons";
import { CSVLink } from "react-csv";

import { Typography, Dropdown, PageLoader } from "clearsense-ui/components";

import { renderChart } from "./renderChart";

const MaximizedChart = ({
  maximizedChart,
  tables,
  tablePageInfo,
  setTablePageInfo,
  setMaximizedChart,
  setViewQuery,
  downLoadAsJPEG,
}) => (
  <div
    data-cy="maximized-chart"
    id={`${maximizedChart.id}-full`}
    className="fullscreen-chart absolute top-0 right-0 bottom-0 left-0 bg-white dark:bg-cs-ui-gray-800 p-4 pb-8 space-y-1.5"
  >
    <div className="flex justify-between">
      <Typography
        style="h4"
        type="semibold"
        className="capitalize"
        data-cy="maximized-chart-title"
      >
        {maximizedChart.title}
      </Typography>
      <Dropdown
        data-cy="maximized-chart-dropdown-button"
        data-html2canvas-ignore="true"
        buttonStyle="text"
        buttonProps={{
          icon: MenuVertical,
        }}
      >
        <li onClick={() => setViewQuery(maximizedChart.sql_query)}>
          View Query
        </li>
        <li
          onClick={() =>
            downLoadAsJPEG(`${maximizedChart.id}-full`, maximizedChart.title)
          }
        >
          Download as image
        </li>
        <li>
          <CSVLink
            data={tables?.[maximizedChart?.id] || ""}
            filename={`${maximizedChart.title}.csv`}
            target="_blank"
          >
            Export as CSV
          </CSVLink>
        </li>
        <li onClick={() => setMaximizedChart("")} data-cy="minimize-chart-text">
          Minimize Chart
        </li>
      </Dropdown>
    </div>
    {!tables[maximizedChart.id] ? (
      <PageLoader />
    ) : (
      <>
        {renderChart({
          chartData: maximizedChart,
          tables,
          tablePageInfo,
          setTablePageInfo,
        })}
      </>
    )}
  </div>
);

export default MaximizedChart;
